<script setup lang="ts">
/**
 * Фон приложения: два статичных радиальных градиента + линейная сетка
 * 96×96px. Без анимации и без backdrop-filter — намеренно, ради
 * производительности (см. docs/design-handoff/README.md, «Микро-анимации»).
 * Оба слоя фиксированы (position: fixed) и лежат позади контента (z-index 0),
 * не перехватывают события мыши.
 */
</script>

<template>
  <div class="app-backdrop" aria-hidden="true"></div>
  <div class="app-grid" aria-hidden="true"></div>
</template>

<style scoped>
.app-backdrop {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background:
    radial-gradient(120% 90% at 12% -10%, rgba(111, 147, 191, 0.12), transparent 58%),
    radial-gradient(100% 80% at 95% 105%, rgba(129, 137, 196, 0.08), transparent 62%);
}

.app-grid {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background-image:
    linear-gradient(rgba(233, 237, 242, 0.035) 1px, transparent 1px),
    linear-gradient(90deg, rgba(233, 237, 242, 0.035) 1px, transparent 1px);
  background-size: 96px 96px;
}
</style>
